export enum ETattoo {
  'One' = 'one',
  'Two' = 'two',
  'Three' = 'three',
  'Four' = 'four',
  'Five' = 'five',
  'Six' = 'six',
  'Seven' = 'seven'
}

export const tattoos = [
  ETattoo.One,
  ETattoo.Two,
  ETattoo.Three,
  ETattoo.Four,
  ETattoo.Five,
  ETattoo.Six,
  ETattoo.Seven
]
